import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip loading indicator for specific requests if needed
    // You can add custom logic here, e.g., skip for certain URLs
    const skipLoading = request.headers.has('X-Skip-Loading');

    if (skipLoading) {
      const headers = request.headers.delete('X-Skip-Loading');
      const clonedRequest = request.clone({ headers });
      return next.handle(clonedRequest);
    }

    // Start loading
    this.loadingService.startLoading();

    return next.handle(request).pipe(
      finalize(() => {
        // Stop loading when request completes (success or error)
        this.loadingService.stopLoading();
      })
    );
  }
}
